<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (highSpeedAirflowSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">High Airflow:</label>
            <input type="number" class="configurationRatingTextInput" #airflowInput
              [value]="highSpeedAirflowSelection.Value"
              (change)="selectionChanged(highSpeedAirflowSelection, airflowInput.value || '0')">
            <label class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits() }}</label>
          </span>
        }
        @if (espSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">ESP:</label>
            <input type="number" class="configurationRatingTextInput" #espInput [value]="espSelection.Value"
              step="0.01" (change)="selectionChanged(espSelection, espInput.value || '0')">
            <label class="configurationRatingUnitLabel">{{ getPressureMeasurementUnits() }}</label>
          </span>
        }
        @if (altitudeSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Altitude:</label>
            <input type="number" class="configurationRatingTextInput" #altitudeInput
              [value]="altitudeSelection.Value"
              (change)="selectionChanged(altitudeSelection, altitudeInput.value || '0')">
            <label class="configurationRatingUnitLabel">{{ getDistanceMeasurementUnits() }}</label>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (inputTypeSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Input Type:</label>
            <select class="configurationInputField" #inputTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(inputTypeSelection.Name)"
              (change)="inputTypeChanged(inputTypeInput.value)" [value]="inputTypeSelection.Value">
              @for (allowable of inputTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                            [selected]="inputTypeSelection.Value != undefined && inputTypeSelection.Value != null
                                     && inputTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        <span class="configurationInput"></span>
        <span class="configurationInput"></span>
      </div>
      <app-performance-input [engineKey]="engineKey()" [selectionEntities]="selectionEntities()" [isMetric]="isMetric"
        (valueChanged)="performanceValueChanged()">
      </app-performance-input>
      @if (ratingResponseError) {
        <div class="ratingError">
          {{ ratingResponseError }}
        </div>
      }
    </div>
  }
</div>
